import React from 'react';
import {ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import enGB from 'antd/lib/locale-provider/en_GB';
import moment from 'moment';
import 'moment/locale/zh-cn'; // 解决 antd 日期组件国际化问题
import {connect} from '@/models';
import allI18n, {defaultLang} from './index';

@connect(state => {
    return {
        local: state.system.local,
        autoLocal: state.system.autoLocal,
    }
})
export default class Local extends React.Component {
    constructor(...props) {
        super(...props);
        let {local, autoLocal} = this.props;

        // 不基于浏览器自动获取，将语言设置为默认
        if (!autoLocal) local = defaultLang?.local;

        // 从浏览器存储中恢复语言
        const storeLocal = window.localStorage.getItem('system-local');
        if (storeLocal) {
                let langV2 = storeLocal;
                let lang2 = storeLocal.toLowerCase().replace('_', '-');

                if (lang2.startsWith('zh-')&&lang2.endsWith('-cn')) {
                    lang2 = 'zh';
                }else if(lang2.startsWith('zh-')){
                    lang2 = 'zh-TW';
                }
                const langAbbreviate = lang2.split('-')[0];
                langV2 = langAbbreviate==='zh'?lang2:langAbbreviate;
                if(storeLocal !== langV2){
                    window.localStorage.setItem('system-local', langV2); 
                }
        }
 

        // 如果没有选择过语言，通过浏览器获取语言
        if (!local && autoLocal) {
            local = getLocalByBrowser();
        }


        this.props.action.system.setLocal(local);

        function getLocalByBrowser() {
            const type = navigator.appName;
            const defaultLocal = 'en'; // 如果未获取到，默认语言为英文
            let lang;

            if (type === 'Netscape') {
                lang = navigator.language.toLowerCase(); // 获取浏览器配置语言，支持非IE浏览器
            } else {
                lang = navigator.userLanguage.toLowerCase(); // 获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
            }

            if (!lang) return defaultLocal;

            lang = lang.replace('_', '-');

            if (lang.startsWith('zh-')&&lang.endsWith('-cn')) {
                lang = 'zh';
            }else if(lang.startsWith('zh-')){
                lang = 'zh-TW';
            }
            const langAbbreviate = lang.split('-')[0];
            let langV2 = langAbbreviate==='zh'?lang:langAbbreviate;


            const exactLang = allI18n.find(item => item.local === langV2);
            const firstTowCharLang = allI18n.find(item => item.local.substr(0, 2) === lang.substr(0, 2));

            // 完全匹配了
            if (exactLang) return exactLang.local;

            // 前两位匹配
            if (firstTowCharLang) return firstTowCharLang.local;

            // 未查找到匹配的语言，设置成默认语言
            return defaultLocal;
        }
    }


    render() {
        const {children, local} = this.props;

        const findI18nItem =  allI18n.find(item => item.local === local);
        const antLocal =  findI18nItem?.antLocal||'zh_CN';
        // FIXME 更多语言支持
        const momentLocalMap = {
            'zh_CN': 'zh-cn',
            'en_GB': 'en-gb',
        };
        const antLocalMap = {
            'zh_CN': zhCN,
            'en_GB': enGB,
        };
        
        const momentLocal = momentLocalMap[antLocal];
        if (momentLocal) moment.locale(momentLocal);

        const antLan = antLocalMap[antLocal];

        window.top.document.title = findI18nItem?.i18n?.application?.name
        // if(local.indexOf('ar')===0){
        //     // 阿拉伯语
        //     window.document.body.style.direction = 'rtl'
        //     window.document.body.style.textAlign = 'right'
        // }else{
        //     window.document.body.style.direction = 'ltr'
        //     window.document.body.style.textAlign = 'left'
        // }

        return (
            <ConfigProvider locale={antLan}>
                {children}
            </ConfigProvider>
        );
    }
}
